import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	FeatureFlagRequest,
	GetCheckFeaturesModel,
	GetCheckFeatures,
} from 'domain/usecases/private/check-features/get-check-features';

export class RemoteGetCheckFeatures implements GetCheckFeatures {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetCheckFeaturesModel>,
	) {}

	async get(params?: FeatureFlagRequest): Promise<GetCheckFeaturesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
